import { render, staticRenderFns } from "./back-top.vue?vue&type=template&id=134b6eaf&"
import script from "./back-top.vue?vue&type=script&lang=js&"
export * from "./back-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('134b6eaf')) {
      api.createRecord('134b6eaf', component.options)
    } else {
      api.reload('134b6eaf', component.options)
    }
    module.hot.accept("./back-top.vue?vue&type=template&id=134b6eaf&", function () {
      api.rerender('134b6eaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back-top/back-top.vue"
export default component.exports